export default __webpack_public_path__ + "media/images/images_v2/pagination-0eeb74bd70f78488e7c18cb2a69a7a67.png";